module.exports = __webpack_public_path__ + "img/DB1GLOBAL_BANNER.e1805b7b.png";